<lib-bar-tag
  [orderStatus]="orderStatus"
  [className]="currentPaymentMethod ? 'payment active' : 'payment'"
  [icon]="'credit_card'"
  [fillIcon]="false"
  [text]="
    paymentMethod === null
      ? 'No Payment Method'
      : (paymentMethod?.description ?? '')
  "
  [actionName]="actionName"
  [isActionClickable]="actionCallback !== undefined ? true : false"
  (clickedAction)="actionCallback !== undefined ? actionCallback() : null"
/>

<ng-template #applyDialog>
  <h2 matDialogTitle>Update your payment method</h2>
  <mat-dialog-content>
    <!-- Date picker section that shows when payment date is in the past -->
    @if (isDateInPast) {
      <div class="date-picker-section">
        <p>
          Your {{ orderVerboseName }} was scheduled to process on date
          {{ NODDate | dateFormat: "MMM d, YYYY" }}, which is in the past.
        </p>
        <p>Please select a new date for your {{ orderVerboseName }}:</p>
        <lib-nod-date-picker
          [date]="defaultDate"
          [config]="nodPickerConfig"
          (dateChanged)="onDateChanged($event)"
        />
      </div>
    }
    <p>
      Apply {{ paymentMethod?.description }} as your payment method to your
      {{ orderVerboseName }}?
    </p>
  </mat-dialog-content>
  <mat-dialog-actions style="justify-content: flex-end">
    <md-text-button form="form-id" value="cancel" matDialogClose
      >Cancel</md-text-button
    >
    <md-text-button
      form="form-id"
      value="process"
      (click)="applyAndProcess()"
      [disabled]="!resumeEnabled"
    >
      {{
        orderStatus === "failed"
          ? "Update and Retry Processing"
          : "Update and Process Now"
      }}
    </md-text-button>
    <md-text-button
      *ngIf="orderStatus === 'failed' && errorCode === 2000"
      form="form-id"
      value="resume"
      (click)="resumeAndApplyPayment()"
      [disabled]="!resumeEnabled"
    >
      Resume and Confirm
    </md-text-button>
    <md-text-button
      form="form-id"
      value="confirm"
      (click)="onApplyPayment()"
      [disabled]="!resumeEnabled"
    >
      Confirm
    </md-text-button>
  </mat-dialog-actions>
</ng-template>
